import { render, staticRenderFns } from "./ContactCategoryTag.vue?vue&type=template&id=91bc15ee&scoped=true&"
import script from "./ContactCategoryTag.vue?vue&type=script&lang=ts&"
export * from "./ContactCategoryTag.vue?vue&type=script&lang=ts&"
import style0 from "./ContactCategoryTag.vue?vue&type=style&index=0&id=91bc15ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bc15ee",
  null
  
)

export default component.exports